import { useState } from 'react';
import {
	GovDropdown,
	GovFormControl,
	GovIcon,
	GovTag,
} from '@gov-design-system-ce/react';
import type { DatovkaApiType } from '@gov-nx/api';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	dataBoxLabel,
	useDataBoxMessageFormContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button } from '../../Button/Button';
import { DataBoxRecipientDetailContent } from './DataBoxRecipientDetailContent';

export const DataBoxRecipientDetail = ({
	dataBox,
}: {
	dataBox: DatovkaApiType;
}) => {
	const { onRecipientRemove } = useDataBoxMessageFormContext();
	const [showDetail, setShowDetail] = useState(false);
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	return (
		<GovFormControl className="ds-new-message ds-recipient-detail">
			<label className="gov-form-label__label">
				{tn('nova-zprava.komu')}:
				<span className="gov-color--text-status-error">&nbsp;*</span>
			</label>
			<GovDropdown
				position="left"
				color="primary"
				type="base"
				size="s"
				open={showDetail}
				label={
					<GovTag
						color="primary"
						size="s"
						type="subtle"
						className="pr-0!"
						onGov-click={() => setShowDetail(true)}>
						{dataBoxLabel(dataBox, true)}
						<Button
							color="primary"
							type="base"
							aria-label={tn('nova-zprava.zavrit-vse')}
							size="s"
							onClick={onRecipientRemove}>
							<GovIcon
								slot="icon-end"
								name="x-lg"
								type="components"
							/>
						</Button>
					</GovTag>
				}>
				<DataBoxRecipientDetailContent dataBox={dataBox} />
			</GovDropdown>
		</GovFormControl>
	);
};
